export enum MapValueMode {
  primary = 'primary',
  comparison = 'comparison',
  difference = 'difference',
}
